import React from 'react';
import { IssueContentType } from '@/types/model';

const ContentTypeBadge: React.FC<{ type: IssueContentType }> = ({ type }) => {
  const typeConfig = {
    TV_CHANNEL: { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Canal de TV' },
    MOVIE: { bg: 'bg-purple-100', text: 'text-purple-800', label: 'Película' },
    DOCUMENTARY: { bg: 'bg-green-100', text: 'text-green-800', label: 'Documental' },
    SPORT: { bg: 'bg-orange-100', text: 'text-orange-800', label: 'Deportes' },
    CONCERT: { bg: 'bg-pink-100', text: 'text-pink-800', label: 'Concierto' },
    TV_SHOW_EPISODE: { bg: 'bg-indigo-100', text: 'text-indigo-800', label: 'Episodio' },
    TV_SHOW: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Serie' },
    TRAILER: { bg: 'bg-gray-100', text: 'text-gray-800', label: 'Trailer' },
    RADIO_STATION: { bg: 'bg-teal-100', text: 'text-teal-800', label: 'Emisora' }
  };

  const config = typeConfig[type];

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      {config.label}
    </span>
  );
};

export default ContentTypeBadge;
